import fetch from "../../auth/FetchInterceptor";

export const getVendors = function (perPage, page) {
  return fetch({
    url: `/vendors?per_page=${perPage}&page=${page}`,
    method: 'get',
  })
}

export const getVendor = (tagId) => {
  return fetch({
    url: `/vendors/${tagId}`,
    method: 'GET',
  });
}

export const createVendor = (data) => {
  return fetch({
    url: `/vendors`,
    method: 'POST',
    data,
  });
}

export const updateVendor = (id, data) => {
  return fetch({
    url: `/vendors/${id}`,
    method: 'PUT',
    data,
  });
}

export const deleteVendor = (id) => {
  return fetch({
    url: `/vendors/${id}`,
    method: 'DELETE',
  });
}